import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';

export const getOfferings = async () => {
  const response = await axiosInstance.get(ApiUrlConstant.getOfferings());
  return response.data;
};

export const updateOfferingPrice = async (offeringId, price) => {
  const response = await axiosInstance.patch(`/api/accounts/offerings/${offeringId}/update-price/`, {
    price: price,
  });
  return response.data;
};

export const syncMdiOfferings = async () => {
  const response = await axiosInstance.post('/api/accounts/offerings/sync-mdi/');
  return response.data;
};

export const bulkUpdateOfferings = async (offerings) => {
  const response = await axiosInstance.post(ApiUrlConstant.bulkUpdateOfferings(), { offerings });
  return response.data;
};
